import React, { Component } from 'react';

class Loading extends Component {
  render() {
    return (
      <div className="page-loading-container">
        <div className="loading">
        </div>
        <div className="loading-text">
          LOADING...
        </div>
      </div>
    );
  }
}

export default Loading;


// WEBPACK FOOTER //
// ./src/components/loading/index.js